export default "__VITE_PUBLIC_ASSET__87aa46b1__"